import { render, staticRenderFns } from "./LoginFrame.vue?vue&type=template&id=00ece7a8&scoped=true&"
import script from "./LoginFrame.vue?vue&type=script&lang=js&"
export * from "./LoginFrame.vue?vue&type=script&lang=js&"
import style0 from "./LoginFrame.vue?vue&type=style&index=0&id=00ece7a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ece7a8",
  null
  
)

export default component.exports